import React from "react";
import "./Landing.css";

import circle from "../assets/landing_circle.png";
import doc from "../assets/landing_doc.png";
import logo from "../assets/landing_logo.png";

import { Button } from "antd";
import { Link } from "react-router-dom";

function Landing() {
  return (
    <div>
      <h1 className="heading_landing">
        Revolutionlising hospital management system to save lives efficiently.
      </h1>

      <p className="p_landing">
        A centralized database of a medical history of users in case of an
        emergency which is accessed by verified doctors. A one-stop application
        to store, share, and view medical history. Authorize access to trusted
        ones, maintaining security as well as have a digital copy saved rather
        than scattered paperwork.
      </p>

      <img alt="circle" className="circle_landing" src={circle}></img>
      <img alt="doc" className="circle_doc" src={doc}></img>
      <img alt="logo" className="circle_logo" src={logo}></img>

      <div className="Button_grp_landing">
        <Button className="btn_landing">
          <Link to="signin">Login as doctor</Link>
        </Button>
        <Button className="first_btn btn_landing">
          <Link to="signup">Login as Patient</Link>
        </Button>
      </div>
    </div>
  );
}

export default Landing;
